export { default as generateInfoUpdateData } from './generateInfoUpdateData';
export { default as normalizeRequestData } from './normalizeRequestData';
export * from './constants';
export type * from './model';

export const labelShimmerWidth = (index: number) => 100 + ((10 * index) % 33);
export const valueShimmerWidth = (index: number) => 250 + ((20 * index) % 44);

export const PLACEHOLDER_COUNT = 8;
